export class EmployeeModel {
  _id: String | undefined;
  fullName!: String | undefined;
  employeeNumber: String | undefined;
  position: String | undefined;
  companyId: String | undefined;
  licenseNumbers: any | undefined;
  authorizeEquipments: any | undefined;
  department: any | undefined;
  section: String | undefined;
  phone: String | undefined;
  licenseDetails: LicenseDetails | undefined;
}
export class LineManager {
  fullName: String | undefined;
  position: String | undefined;
}
export class LicenseDetails {
  licenseNumber: String | undefined;
  issuedDate: Date | undefined;
  expiryDate: Date | undefined;
  authorizedEquipment: AuthorizedEquipment | undefined;
}
export class AuthorizedEquipment {
  name: String | undefined;
  subtitle: String | undefined;
}
